package com.milta.core.localization.translations.bg

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "История на маршрутите",
    periodLabel = "Период",
    periodLastEightDays = "Последните 8 дни",
    periodSingleDate = "Конкретна дата",
    periodRange = "Период от дати",
    rangeFromLabel = "От",
    rangeToLabel = "До",
    driverFilterLabel = "Шофьор",
    driverFilterAllOption = "Всички шофьори",
    historySearchLabel = "Търсене",
    historySearchPlaceholder = "Търсене на шофьор, получател, адрес, причина…",
    columnDate = "Дата",
    columnDriver = "Шофьор",
    columnTotalDeliveries = "Общо доставки",
    columnDelivered = "Доставени",
    columnFailed = "Неуспешни",
    viewProofsAction = "Вижте доказателствата",
    emptyHistoryMessage = "Няма намерени маршрути за този период.",
    errorInvalidPeriod = "Избраният период не е валиден.",
    screenBTitle = "История на доказателствата за доставка",
    routeOfLabel = "Маршрут от",
    totalDeliveriesLabel = "доставки",
    deliveredLabel = "доставени",
    failedLabel = "неуспешни",
    backToHistoryAction = "История на маршрутите",
    statusDeliveredBadge = "Доставено",
    statusFailedBadge = "Неуспешно",
    viewReasonAction = "Вижте причината",
    hideReasonAction = "Скрий причината",
    photoPlaceholderAlt = "Няма налична снимка",
    photoAlt = "Доказателство за доставка",
    emptyProofsMessage = "Няма налично доказателство за доставка за този маршрут.",
    proofsSearchLabel = "Търсене на доставка",
    proofsSearchPlaceholder = "Търсене на получател, адрес, причина…",
    paginationPrevious = "Предишна",
    paginationNext = "Следваща",
)
